import { useEffect, useState } from 'react';

interface EstadoLogin {
  google: boolean;
  desarrollo: boolean;
}

export function Login({ alEntrar }: { alEntrar: () => void }) {
  const [estado, setEstado] = useState<EstadoLogin | null>(null);

  useEffect(() => {
    fetch('/auth/estado', { credentials: 'same-origin' })
      .then((r) => r.json())
      .then(setEstado)
      .catch(() => setEstado({ google: true, desarrollo: false }));
  }, []);

  async function entrarEnDesarrollo() {
    await fetch('/auth/desarrollo', { method: 'POST', credentials: 'same-origin' });
    alEntrar();
  }

  return (
    <div className="pantalla-centrada portada">
      {/* El logotipo de Gextia manda: la app escribe en Gextia y es lo que el
          usuario reconoce. FactorLibre va abajo, como quien la hace. */}
      <img
        className="marca-gextia"
        src="/marca/gextia-logotipo.png"
        alt="Gextia"
        width={200}
        height={69}
      />
      <h2>Gastos</h2>
      <p>
        Crea tus notas de gastos y engancha las fotos de los tickets sin salir del
        móvil.
      </p>

      {estado?.google !== false && (
        <>
          {/* Navegación normal, no fetch: el flujo de OAuth necesita que el
              navegador siga las redirecciones de Google. */}
          <a className="boton ancho" href="/auth/google">
            Entrar con Google
          </a>
          <p className="tarjeta-meta">Solo cuentas de FactorLibre.</p>
        </>
      )}

      {estado?.desarrollo && (
        <>
          <button
            type="button"
            className="boton secundario ancho"
            onClick={() => void entrarEnDesarrollo()}
          >
            Entrar en modo desarrollo
          </button>
          <p className="aviso atencion">
            Este servidor tiene abierta la puerta de desarrollo. No es un entorno
            real.
          </p>
        </>
      )}

      <footer className="firma">
        <span>Una herramienta de</span>
        {/* Dos ficheros, no un filtro: el logotipo lleva rojo de marca, e
            invertirlo para el modo oscuro lo volvía cian. FactorLibre publica
            la versión clara, que es la que toca sobre fondo oscuro. */}
        <picture>
          <source
            srcSet="/marca/factorlibre-claro.png"
            media="(prefers-color-scheme: dark)"
          />
          <img src="/marca/factorlibre.png" alt="FactorLibre" width={110} height={19} />
        </picture>
      </footer>
    </div>
  );
}
